<template>
  <div class="aibuy-page">
    <SearchNav ref="search" />
    <div class="content">
      <div class="ai-header">
        <div class="startInput" v-show="showStartInput()" @click="startInput">导入采购清单</div>
        <div class="restart" v-show="showRestart()" @click="restart">重新匹配</div>
      </div>
      <div class="scroll-content">
        <template v-if="matchMessage.matchStatus == -1">
          <div class="noMatch">
            <div class="msg">
              <img :src="require('../../../assets/img/aibuy-null.png')" alt="" />
              <div>暂时没有匹配到对应的采购商哦，请上传其他采购清单</div>
            </div>
          </div>
        </template>
        <template v-else-if="matchMessage.matchStatus == 4">
          <div class="matchError">
            <div class="msg">
              <img :src="require('../../../assets/img/ai-buy-fit-error.png')" alt="" />
              <div>商品匹配异常</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="infinite-list">
            <div class="loadingdata-null" v-if="matchMessage.matchStatus == 3 && ListMessage.data.length == 0">
              <img :src="require('@/assets/img/ai-buy-no-fit.png')" alt="" />
              <div>没有匹配到任何商品</div>
            </div>
            <div class="loadingdata" v-else-if="ListMessage.data.length == 0">
              <img :src="require('@/assets/img/loading.gif')" alt="" />
              <div>商品正在加载中，请稍等</div>
            </div>
            <DynamicScroller key-field="detailId" :items="ListMessage.data" :min-item-size="160" class="virtual-list">
              <template v-slot="{ item, index, active }">
                <DynamicScrollerItem :item="item" :active="active" :data-index="index">
                  <shopItem :info="item" :isEnd="index == ListMessage.data.length - 1"></shopItem>
                </DynamicScrollerItem>
              </template>
            </DynamicScroller>
          </div>
        </template>
      </div>
    </div>
    <div class="ai-footer" v-show="aiFooterShow">
      <div class="container">
        <div class="process">
          数据加载进度:
          <span>{{ matchPercent }}%...</span>
        </div>
        <div class="totalCount">
          共
          <span>{{ matchMessage.matchedNum }}</span>
          个数据
        </div>
        <div class="downloadExcle" v-show="matchMessage.matchedFileUrl" @click="openUrl">
          <i class=""></i>
          <span>下载报价单</span>
        </div>
      </div>
    </div>
    <el-dialog title="上传采购清单" :visible.sync="aiDialog" width="small" alignFooter="right">
      <div class="body" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <aiUpload @change="FileChange()" ref="aiupload"></aiUpload>
        <div class="dialog-footer">
          <el-button @click="cancleUpload">取 消</el-button>
          <el-button type="primary" :disabled="subMitdisabled" @click="submitExcle">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import SearchNav from '@/components/SearchNav';
import { aiBuy } from '@/services/index';
import aiUpload from './component/upload';
import shopItem from './component/shopItem';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'; // 引入它的 css
import VueVirtualScroller from 'vue-virtual-scroller';
import Vue from 'vue';
import _uniqWith from 'lodash/uniqWith';
import _uniqBy from 'lodash/uniqBy';
import _clone from 'lodash/clone';

Vue.use(VueVirtualScroller);
const EmatchStatus = {
  waitMatch: 1,
  matchRun: 2,
  matchEnd: 3,
  matchError: 4,
  noMatch: -1
};
const ListMessage = {
  pageNo: 1,
  pageSize: 10,
  data: [],
  interval: 5000
};
export default {
  components: { SearchNav, aiUpload, shopItem },
  data() {
    return {
      count: 0,
      aiDialog: false,
      matchMessage: {
        matchMessage: null,
        matchPercent: null,
        matchStatus: null,
        matchedFileUrl: null,
        matchedNum: null
      },
      subMitdisabled: true,
      getMathInfoTimer: null,
      autoLoadDataTimer: null,
      ListMessage: _clone(ListMessage),
      loading: false
    };
  },
  computed: {
    matchPercent() {
      return Number(this.matchMessage.matchPercent).toFixed(1);
    },
    aiFooterShow() {
      const { matchedNum, matchStatus } = this.matchMessage;
      if (matchedNum > 0 || matchStatus == EmatchStatus.matchEnd) {
        return true;
      }
    }
  },
  mounted() {
    this.$store.dispatch('layout/SET_FOOTER', false);
    Telescope.trackPage({
      trackId: 'zyb2bpc-page-qt-zncgyB2B'
    });
    this.getMathInfo(true);
  },
  beforeDestroy() {
    this.$store.dispatch('layout/SET_FOOTER', true);
    this.clearAllTimer();
  },

  methods: {
    openFullScreen() {
      this.loading = true;
    },
    closeFullScreen() {
      this.loading = false;
    },
    resetData() {
      this.ListMessage = _clone(ListMessage);
      this.matchMessage = {
        matchMessage: null,
        matchPercent: null,
        matchStatus: null,
        matchedFileUrl: null,
        matchedNum: null
      };
      const { aiupload } = this.$refs;
      aiupload && aiupload.clear();
    },
    showRestart() {
      const { matchStatus } = this.matchMessage;
      if (matchStatus == EmatchStatus.matchEnd) {
        return true;
      }
    },
    showStartInput() {
      const { matchStatus } = this.matchMessage;
      if (matchStatus == EmatchStatus.matchRun || matchStatus == EmatchStatus.waitMatch) {
        return false;
      }
      return true;
    },
    async restart() {
      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-qt-zncgydwhfB2B'
      });
      this.resetData();
      const { resetResult, resetMessage } = await aiBuy.reset_purchase_list_match();
      if (resetResult) {
        this.getMathInfo(true);
      } else {
        this.$alert(resetMessage, '警告', {
          confirmButtonText: '确定'
        });
      }
    },
    clearAllTimer() {
      clearTimeout(this.autoLoadDataTimer);
      clearTimeout(this.getMathInfoTimer);
    },
    openUrl() {
      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-sy-zncgyxzbjdB2B'
      });
      window.open(this.matchMessage.matchedFileUrl);
    },
    async submitExcle() {
      const { aiupload } = this.$refs;
      const { url } = aiupload.getFile();
      this.openFullScreen();
      try {
        const res = await aiBuy.purchase_list_match({
          fileUrl: url
        });
        this.closeFullScreen();
        if (res.matchCode) {
          this.aiDialog = false;
          this.resetData();
          this.getMathInfo(true);
        } else {
          this.$alert(res.matchMessage, '警告', {
            confirmButtonText: '确定'
          });
        }
      } catch (e) {
        this.closeFullScreen();
      }
    },
    autoLoadData() {
      // 自动加载列表数据
      const { matchStatus, matchedNum } = this.matchMessage;
      if (matchStatus == EmatchStatus.matchError) {
        return;
      } else if (matchStatus == EmatchStatus.matchEnd && matchedNum == 0) {
        return;
      }
      clearTimeout(this.autoLoadDataTimer);
      this.autoLoadDataTimer = setTimeout(() => {
        this.getMathResult();
      }, this.ListMessage.interval);
    },
    autoLoadInfo(first) {
      // 自动加载info数据
      clearTimeout(this.getMathInfoTimer);
      this.getMathInfoTimer = setTimeout(() => {
        this.getMathInfo(first);
      }, 5000);
    },
    cancleUpload() {
      const { aiupload } = this.$refs;
      aiupload.clear();

      this.aiDialog = false;
    },
    FileChange() {
      const { aiupload } = this.$refs;
      if (aiupload.getFile()) {
        this.subMitdisabled = false;
      } else {
        this.subMitdisabled = true;
      }
    },
    startInput() {
      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-qt-zncgydrcgqdB2B'
      });
      this.aiDialog = true;
    },

    toast(msg, time = 3000) {
      this.$message.closeAll();
      this.$message({
        message: msg,
        type: 'success',
        duration: time
      });
    },
    async getMathResult() {
      const { pageNo, pageSize } = this.ListMessage;
      const { matchStatus, matchedNum } = this.matchMessage;
      try {
        const res = await aiBuy.getMatchResult({
          pageNo,
          pageSize
        });
        this.autoLoadData();
        if (res.data && res.data.length) {
          console.log(`已更新${res.data.length}条数据`);
          if (res.data.length == pageSize) {
            this.ListMessage.pageNo++;
          }
          const resData = res.data.map((el) => {
            return { ...el, id: el.matchInfo.itemCode };
          });
          const mergeData = [...this.ListMessage.data, ...resData];
          const uniqData = _uniqBy(mergeData, 'detailId');
          this.ListMessage.data = uniqData;
          if (matchStatus == EmatchStatus.matchEnd) {
            if (uniqData.length >= matchedNum) {
              // this.toast(`共${uniqData.length}条数据 已加载完成`);
              this.clearAllTimer();
            }
          }
        }
      } catch (e) {
        this.autoLoadData();
      }
    },

    async getMathInfo(first = false) {
      if (first) {
        this.clearAllTimer();
      }
      try {
        const res = await aiBuy.getMathInfo();
        this.matchMessage = res;
        const { matchStatus, matchedFileUrl, matchMessage } = this.matchMessage;
        clearTimeout(this.getMathInfoTimer);
        if (matchStatus == EmatchStatus.noMatch) {
          // 没有开始匹配过
          return;
        }
        if (matchStatus == EmatchStatus.matchError) {
          this.$alert(matchMessage, '提示', {
            confirmButtonText: '确定'
          });
          return;
        }
        if (matchStatus == EmatchStatus.waitMatch || matchStatus == EmatchStatus.matchRun) {
          this.autoLoadInfo();
        }
        if (matchStatus == EmatchStatus.matchEnd) {
          if (!matchedFileUrl) {
            this.autoLoadInfo();
          }
        }
        if (first) {
          this.getMathResult();
        }
      } catch (e) {
        //防止接口挂了 直接走不下去了
        this.autoLoadInfo(first);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.aibuy-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }
  /deep/ .aiDialog {
  }
  /deep/ .aiDialog-text {
    padding: 10px 0;
    font-size: 12px;
    color: #8c8c8c;
  }
  /deep/ .upload-demo {
    width: 100%;
    .el-upload {
      display: block;
      .el-upload-dragger {
        width: 100%;
      }
    }
  }
  @mixin baseBtn($bg: #fff, $fz: 12px, $color: #333) {
    padding: 8px 16px;
    background: $bg;
    cursor: pointer;
    font-size: $fz;
    color: $color;
  }

  .ai-footer {
    background: #fafafa;
    display: flex;
    align-items: center;
    justify-content: center;
    .container {
      width: 1232px;
      height: 70px;
      display: flex;
      align-items: center;
      @mixin baseFont($color: #333) {
        color: #333;
        font-size: 14px;
        font-weight: 400;
        span {
          color: $color;
        }
      }
      .process {
        @include baseFont;
      }
      .totalCount {
        margin-left: 24px;
        @include baseFont(#d96900);
      }
      .downloadExcle {
        @include baseBtn($fz: 16px);
        border: 1px solid #edeeef;
        margin-left: 24px;
      }
    }
  }
  .content {
    //border-top: 1px solid #eee;
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
    overflow: hidden;
    .ai-header {
      padding: 16px 0;
      display: flex;
      .startInput {
        @include baseBtn($bg: #1e8dff, $color: #fff);
      }
      .restart {
        @include baseBtn($bg: #1e8dff, $color: #fff);
        margin-left: 16px;
      }
    }
    .scroll-content {
      flex: 1;
      background: #fafafa;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .infinite-list {
        display: flex;
        flex-direction: column;
        flex: 1;
        position: relative;
        overflow: hidden;
        .virtual-list {
          //flex: 1;
          //height: 500px;
        }
        .loadingdata {
          position: absolute;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          z-index: 10;
          img {
          }
          color: #8c8c8c;
          font-size: 14px;
        }
        .loadingdata-null {
          @extend .loadingdata;
          img {
            width: 160px;
            height: 160px;
          }
        }
      }
    }
    .noMatch {
      display: flex;
      height: 500px;
      .msg {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        img {
          width: 110px;
          height: 110px;
          display: block;
          margin-bottom: 20px;
        }
        div {
          color: #8c8c8c;
          font-size: 14px;
        }
      }
    }
    .matchError {
      @extend .noMatch;
      .mgs {
        img {
          width: 140px;
          height: 140px;
        }
      }
    }
  }
}
</style>
